module.exports = __webpack_public_path__ + "static/media/ecobox.a3f41891.svg";